import { render } from "./AutomatedPayments.vue?vue&type=template&id=d3076c84&scoped=true"
const script = {}

import "./AutomatedPayments.vue?vue&type=style&index=0&id=d3076c84&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3076c84"]])

export default __exports__